module.exports = __webpack_public_path__ + "static/media/DashboardDownloadIcon.f0023fbd.svg";